<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle" ref="header"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr">
          <div class="formArea mt10">
            <select v-on:input="changeOrderId($event.target.value)" ref="orderId" v-model="productIdx" class="ipt" title="카드선택">
              <option value="99" selected="selected">선택해주세요</option>
              <option v-for="(orderAuthBillSummary, key) in orderAuthBillSummaryList" :value="key" :key="key">
                {{ orderAuthBillSummary.orderId }} / {{ orderAuthBillSummary.productName }}
              </option>
            </select>

            <ul class="infoList mt20" v-if="productIdx != 99">
              <li>
                <span class="item">청구일</span>
                <span class="val">{{ currentMonth }}월 {{ dueDate }}</span>
              </li>
              <li>
                <span class="item">청구금액</span>
                <span class="val">{{ payAmounts | currency }}원</span>
              </li>
            </ul>
          </div>
        </section>
        <section class="hr">
          <div class="sortArea">
            <div class="lcont">
              <h2 class="titH4">선결제 금액 입력</h2>
            </div>
            <div class="rcont">
              <div class="txtXS">
                일부 선결제 가능
                <div class="toolTip">
                  <em class="tit">일부선결제란?</em>
                  당월 청구금액 전액이 아닌 최소 금액(1천원) 이상 일부 선결제 가능합니다.
                  <br />
                  잔여 청구금액은 당월 청구일에 청구됩니다.
                </div>
              </div>
            </div>
          </div>
          <div class="formArea">
            <div class="setBtnS">
              <input
                type="tel"
                class="ipt"
                title="결제금액 입력"
                data-unit="원"
                placeholder=""
                value=""
                ref="prePayment"
                v-model="prePayment"
                @mouseout="outPrePayment"
                v-onlyNum
              />
              <button type="button" class="btn_g m" @click="totalAmount">전액</button>
            </div>
            <div class="orderSum" v-if="showResidual">
              <ul class="infoList">
                <li>
                  <span class="item">잔여청구금액</span>
                  <span class="val">
                    <span class="money">{{ reBillingAmount | currency }}원</span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">카드정보 입력</h2>
          </div>
          <div class="formArea">
            <span class="label">카드선택</span>
            <select v-on:input="changeCard($event.target.value)" ref="cardName" v-model="cardName" name="card" class="ipt" title="카드선택">
              <option value="" disabled="disabled" selected="selected">선택해주세요</option>
              <option v-for="(card, index) in rcadCodeList" :value="card.code" :key="index">{{ card.codeName }}</option>
            </select>
            <p class="txtList_remark">본인 결제수단만 진행 가능</p>

            <span class="label">카드번호</span>
            <div class="transkey">
              <div class="setCard">
                <input
                  type="tel"
                  id="cardNum1"
                  class="ipt"
                  maxlength="4"
                  title="카드번호 첫번째 4자리"
                  value=""
                  ref="cardNum1"
                  v-model="cardNum1"
                  nextTarget="cardNum2"
                  v-onlyNum
                  v-skipOfMax
                />
                <span class="sign" aria-hidden="true">-</span>
                <input
                  type="tel"
                  id="cardNum2"
                  class="ipt"
                  maxlength="4"
                  title="카드번호 두번째 4자리"
                  value=""
                  ref="cardNum2"
                  v-model="cardNum2"
                  nextTarget="cardNum3"
                  v-onlyNum
                  v-skipOfMax
                />
                <span class="sign" aria-hidden="true">-</span>
                <input
                  type="tel"
                  class="ipt"
                  maxlength="4"
                  id="cardNum3"
                  nextTarget="cardNum4"
                  title="카드번호 세번째 4자리"
                  v-onlyNum
                  v-skipOfMax
                  value=""
                  data-tk-kbdType="number"
                  onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                />
                <span class="sign" aria-hidden="true">-</span>
                <input
                  type="tel"
                  class="ipt"
                  maxlength="4"
                  id="cardNum4"
                  title="카드번호 마지막 4자리"
                  v-onlyNum
                  v-skipOfMax
                  value=""
                  data-tk-kbdType="number"
                  onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                />
              </div>
            </div>

            <span class="label">유효기간</span>
            <div class="transkey">
              <div class="setPeriod">
                <input
                  type="tel"
                  class="ipt"
                  maxlength="2"
                  id="expirdateMM"
                  nextTarget="expirdateYY"
                  title="유효기간 월 2자리"
                  placeholder="MM"
                  v-onlyNum
                  v-skipOfMax
                  data-tk-kbdType="number"
                  onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                />
                <span class="sign" aria-hidden="true">/</span>
                <input
                  type="tel"
                  class="ipt"
                  maxlength="2"
                  id="expirdateYY"
                  title="유효기간 년 2자리"
                  placeholder="YY"
                  v-onlyNum
                  data-tk-kbdType="number"
                  onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                />
              </div>
            </div>

            <span class="label">비밀번호</span>
            <div class="transkey">
              <div class="setPw">
                <input
                  type="password"
                  class="ipt"
                  id="password"
                  maxlength="2"
                  title="비밀번호 앞 2자리"
                  placeholder="앞 2자리"
                  v-onlyNum
                  data-tk-kbdType="number"
                  onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                />
                <input type="password" class="ipt" maxlength="2" title="비밀번호 뒤 2자리" value="**" readonly="readonly" />
              </div>
            </div>

            <span class="label">생년월일</span>
            <div class="setBirth">
              <input
                type="tel"
                id="ssn1"
                class="ipt"
                maxlength="4"
                title="생년월일 년도 4자리"
                placeholder="1990"
                ref="ssn1"
                v-model="ssn1"
                nextTarget="ssn2"
                v-onlyNum
                v-skipOfMax
              />
              <span class="sign" aria-hidden="true">/</span>
              <input
                type="tel"
                id="ssn2"
                class="ipt"
                maxlength="2"
                title="생년월일 월 2자리"
                placeholder="01"
                ref="ssn2"
                v-model="ssn2"
                nextTarget="ssn3"
                v-onlyNum
                v-skipOfMax
              />
              <span class="sign" aria-hidden="true">/</span>
              <input type="tel" id="ssn3" class="ipt" maxlength="2" title="생년월일 일 2자리" placeholder="01" ref="ssn3" v-model="ssn3" v-onlyNum />
            </div>

            <!--<p class="fieldMsg error" id="idMsg">결제내용에 동의해주세요</p>-->
            <!--<p class="fieldMsg error" id="idMsg2">결제 정보에 오류가 있습니다. 다시 확인해주세요</p>-->

            <p class="txtList_remark">
              선납 결제건에 대한 청구금액 상세항목 및 결제내역 반영에는 전산 적용으로 인해 소정의 시간차가 있을 수 있습니다.
            </p>
            <span class="singleIpt">
              <input type="checkbox" class="ipt" ref="chk2" id="chk2" />
              <label class="normal" for="chk2">
                <span>
                  결제할 항목의 금액정보를 확인했으며 이에 동의합니다.
                  <br />
                  (전자상거래법 제8조2항)
                </span>
              </label>
            </span>
          </div>
        </section>

        <div class="btnArea sticky">
          <button type="button" class="btn_p" @click="goPaymentComplete()" :disabled="duplicatePayCheck">결제하기</button>
        </div>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>

    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
      <template v-slot:bottomButtom v-if="this.messageType == 'paymentComplete'">
        <button type="button" class="btn_p" @click="paymentPopClose">확인</button>
      </template>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import { OVERDUE_AMOUNT_CHECK } from '@/store/message.type';
import { isEmpty } from '@/common/common.function';
import $ from 'jquery';

export default {
  name: 'MonthPrePayment',
  data() {
    return {
      headerTitle: '당월선결제',
      msg: null,
      messagePop: false,
      messageType: '',

      orderAuthBillSummaryList: [],
      productIdx: 99,
      currentMonth: '',
      dueDate: '',
      payAmounts: 0,
      seq: 0,
      orderId: '',
      rcadCodeList: [], // 카드 리스트
      cardName: '',
      cardNumber: '',
      cardExpireDate: '',
      ssn: '',
      duplicatePayCheck: false, // 결제 중복 체크
      prePayment: 0,
      showResidual: false,
      reBillingAmount: 0,

      cardNum1: null,
      cardNum2: null,
      cardNum3: null,
      cardNum4: null,
      expirdateMM: null,
      expirdateYY: null,
      cardPasswd: '',
      ssn1: null,
      ssn2: null,
      ssn3: null,

      taxAmount: 0,
    };
  },
  components: {
    MessagePop,
  },
  beforeDestroy() {
    $("[id^='tooltip_']").remove();
  },
  mounted() {
    this.selectOrderAuthBillSummaryList();
    this.selectCommonCodeList();
    if (process.env.NODE_ENV != 'dev') {
      import('@/raon/welcomeTranskey').then((m) => {
        m.importCSS();
        m.importJS(0, ['cardNum3', 'cardNum4', 'expirdateMM', 'expirdateYY', 'password']);
      });
    }
    //window.importCSS();
    //window.importJS(0, ['cardNum3', 'cardNum4', 'expirdateMM', 'expirdateYY', 'password']); // 보안키패드
  },
  methods: {
    selectOrderAuthBillSummaryList() {
      ApiService.service('GET', '/order/auth/bill/summary')
        .then(({ data }) => {
          let bizDate5 = data.result.bizDate5;
          for (let value of data.result.billInfoList) {
            const month = this.$moment(new Date()).format('MM');
            if (
              value.nextAskDtm >= bizDate5 && // 수납일이 5 영업일 이상 남아있음
              value.currentMonth == month && // 수납월이 당월
              value.overdueAmounts == 0 && // 미납금이 없음
              value.thisMonthAmount * 1 > 0 && // 당월 미수금이 있음
              value.thisMonthAmount == value.payAmounts // 당월 미수금이 채권액과 동일 (선결제 다회 부분납 불가)
            ) {
              this.orderAuthBillSummaryList.push(value);
            }
          }
          for (let i = 0; i < this.orderAuthBillSummaryList.length; i++) {
            if (this.orderAuthBillSummaryList[i].orderId === this.$route.params.orderId) {
              this.productIdx = i;
              break;
            }
          }
          this.changeOrderId(this.productIdx);
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    selectCommonCodeList() {
      ApiService.service('GET', '/common/code/RCAD', '')
        .then(({ data }) => {
          for (let value of data.result) {
            if (value.codePrefix === 'RCAD') {
              this.rcadCodeList = value.codeList;
            }
          }
          this.$refs.orderId.focus();
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    changeOrderId(productIdx) {
      // 선결제 금액 초기화
      this.prePayment = 0;
      this.showResidual = false;
      this.reBillingAmount = 0;

      ///////////////////임시
      this.seq = this.orderAuthBillSummaryList[productIdx].seq;
      this.orderId = this.orderAuthBillSummaryList[productIdx].orderId;
      this.currentMonth = this.orderAuthBillSummaryList[productIdx].currentMonth;
      this.dueDate = this.orderAuthBillSummaryList[productIdx].dueDate;
      this.payAmounts = this.orderAuthBillSummaryList[productIdx].payAmounts;

      // 부가세 세팅
      this.taxAmount = this.orderAuthBillSummaryList[productIdx].payAmounts * 1 * 0.1;
      return;
      ///////////////////임시

      if (productIdx == 99) {
        this.orderId = '';
      } else {
        if (this.orderAuthBillSummaryList[productIdx].overdueAmounts * 1 > 0) {
          this.msg = OVERDUE_AMOUNT_CHECK;
          this.messagePop = true;
          this.seq = 0;
          this.orderId = '';
          this.currentMonth = '';
          this.dueDate = '';
          this.payAmounts = 0;
        } else if (this.orderAuthBillSummaryList[productIdx].thisMonthAmount * 1 == 0) {
          if (this.orderAuthBillSummaryList[productIdx].isNoThisMonth == 'Y') {
            this.msg = '선결제할 당월 렌탈료가 없습니다.';
          } else {
            this.msg = '당월 렌탈료가 이미 납부되었습니다.';
          }

          this.messagePop = true;

          this.seq = 0;
          this.orderId = '';
          this.currentMonth = '';
          this.dueDate = '';
          this.payAmounts = 0;
        } else {
          this.seq = this.orderAuthBillSummaryList[productIdx].seq;
          this.orderId = this.orderAuthBillSummaryList[productIdx].orderId;
          this.currentMonth = this.orderAuthBillSummaryList[productIdx].currentMonth;
          this.dueDate = this.orderAuthBillSummaryList[productIdx].dueDate;
          this.payAmounts = this.orderAuthBillSummaryList[productIdx].payAmounts;

          // 부가세 세팅
          this.taxAmount = this.orderAuthBillSummaryList[productIdx].payAmounts * 1 * 0.1;
        }
      }
      // console.log(this.orderId);
    },
    outPrePayment() {
      this.showResidual = false;

      if (this.orderId === '') {
        this.msg = '상품을 선택해주세요.';
        this.messagePop = true;
        this.messageType = '';
        this.prePayment = 0;
        return false;
      }
      if (this.prePayment === 0 || this.prePayment == '') {
        this.msg = '선결제 금액을 입력해주세요.';
        this.messagePop = true;
        this.messageType = '';
        this.prePayment = 0;
        return false;
      }
      if (this.payAmounts != this.prePayment) {
        // 부가세 이상
        if (this.prePayment < this.taxAmount) {
          this.msg = '최소입금 금액은 월납입료의 10% 이상 금액으로 입금가능합니다.';
          this.messagePop = true;
          this.messageType = '';
          this.prePayment = 0;
          return false;
        } else if (this.prePayment.toString().substring(this.prePayment.toString().length - 3, this.prePayment.toString().length) != '000') {
          this.msg = `결제금액은 1천원 단위로 가능합니다.<br/>금액을 다시 확인해주세요.`;
          this.messagePop = true;
          this.messageType = '';
          this.prePayment = 0;
          return false;
        }
      }
      if (Number(this.payAmounts) < Number(this.prePayment)) {
        this.msg = `선결제 금액이 청구금액보다 큽니다.<br/>금액을 다시 확인해주세요.`;
        this.messagePop = true;
        this.messageType = '';
        this.prePayment = 0;
        return false;
      }

      this.reBillingAmount = this.payAmounts - this.prePayment;

      this.showResidual = true;
    },
    // clickPrePayment() {
    //   this.showResidual = false;
    //
    //   if (this.orderId === '') {
    //     this.msg = '상품을 선택해주세요.';
    //     this.messagePop = true;
    //     this.messageType = '';
    //     return false;
    //   }
    //   if (this.prePayment === 0 || this.prePayment == '') {
    //     this.msg = '선결제 금액을 입력해주세요.';
    //     this.messagePop = true;
    //     this.messageType = '';
    //     return false;
    //   }
    //   if (this.prePayment < 1000) {
    //     this.msg = '결제금액은 1천원 단위로 가능합니다.<br>금액을 다시 확인해주세요.';
    //     this.messagePop = true;
    //     this.messageType = '';
    //     return false;
    //   } else if (this.prePayment.toString().substring(this.prePayment.toString().length-3, this.prePayment.toString().length) !== '000') {
    //     this.msg = '결제금액은 1천원 단위로 가능합니다.<br>금액을 다시 확인해주세요.';
    //     this.messagePop = true;
    //     this.messageType = '';
    //     return false;
    //   }
    //   if (Number(this.payAmounts) < Number(this.prePayment)) {
    //     this.msg = '선결제 금액이 청구금액보다 큽니다.<br>금액을 다시 확인해주세요.';
    //     this.messagePop = true;
    //     this.messageType = '';
    //     return false;
    //   }
    //
    //   this.reBillingAmount = this.payAmounts - this.prePayment;
    //
    //   this.showResidual = true;
    // },
    totalAmount() {
      this.prePayment = 0;
      this.reBillingAmount = 0;

      this.showResidual = false;

      if (this.productIdx != 99) {
        if (this.orderAuthBillSummaryList[this.productIdx].overdueAmounts * 1 > 0) {
          this.msg = OVERDUE_AMOUNT_CHECK;
          this.messagePop = true;
        } else {
          this.prePayment = this.orderAuthBillSummaryList[this.productIdx].payAmounts;
          this.reBillingAmount = this.payAmounts - this.prePayment;

          this.showResidual = true;
        }
      }
    },
    changeCard: function (value) {
      this.cardName = value;
    },
    validate: function () {
      if (this.orderId === '') {
        this.msg = '상품을 선택해주세요.';
        this.messagePop = true;
        this.messageType = '';
        this.$refs.orderId.focus();
        return false;
      }
      if (this.prePayment === 0 || this.prePayment == '') {
        this.msg = '선결제 금액을 입력해주세요.';
        this.messagePop = true;
        this.messageType = '';
        this.$refs.prePayment.focus();
        return false;
      }
      if (this.payAmounts != this.prePayment) {
        if (this.prePayment < this.taxAmount) {
          this.msg = '최소입금 금액은 월납입료의 10% 이상 금액으로 입금가능합니다.';
          this.messagePop = true;
          this.messageType = '';
          this.$refs.prePayment.focus();
          return false;
        } else if (this.prePayment.toString().substring(this.prePayment.toString().length - 3, this.prePayment.toString().length) !== '000') {
          this.msg = `결제금액은 1천원 단위로 가능합니다.<br/>금액을 다시 확인해주세요.`;
          this.messagePop = true;
          this.messageType = '';
          this.$refs.prePayment.focus();
          return false;
        }
      }
      if (Number(this.payAmounts) < Number(this.payAmounts)) {
        this.msg = `선결제 금액이 청구금액보다 큽니다.<br/>금액을 다시 확인해주세요.`;
        this.messagePop = true;
        this.messageType = '';
        this.$refs.prePayment.focus();
        return false;
      }
      if (isEmpty(this.cardName)) {
        this.msg = '카드를 선택해주세요.';
        this.messagePop = true;
        this.messageType = '';
        this.$refs.cardName.focus();
        return false;
      }
      if (isEmpty(this.cardNum1)) {
        this.msg = '카드번호를 입력해주세요.';
        this.messagePop = true;
        this.messageType = '';
        this.$refs.cardNum1.focus();
        return false;
      }
      if (isEmpty(this.cardNum2)) {
        this.msg = '카드번호를 입력해주세요.';
        this.messagePop = true;
        this.messageType = '';
        this.$refs.cardNum2.focus();
        return false;
      }
      /* TODO : 보안키패드 필드 유효성 체크
        if (isEmpty(this.expirdateMM) || isEmpty(this.expirdateYY)) {
          this.msg = '유효기간을 입력해주세요.';
          this.messagePop = true;
          this.messageType = '';
          return false;
        }
        if (isEmpty(this.cardPasswd)) {
          this.msg = '비밀번호를 입력해주세요.';
          this.messagePop = true;
          this.messageType = '';
          return false;
        }*/
      if (isEmpty(this.ssn1)) {
        this.msg = '생년월일을 입력해주세요.';
        this.messagePop = true;
        this.messageType = '';
        this.$refs.ssn1.focus();
        return false;
      }
      if (isEmpty(this.ssn2)) {
        this.msg = '생년월일을 입력해주세요.';
        this.messagePop = true;
        this.messageType = '';
        this.$refs.ssn2.focus();
        return false;
      }
      if (isEmpty(this.ssn3)) {
        this.msg = '생년월일을 입력해주세요.';
        this.messagePop = true;
        this.messageType = '';
        this.$refs.ssn3.focus();
        return false;
      }

      const chk2 = document.getElementById('chk2').checked;

      if (!chk2) {
        this.msg = '필수 동의 사항에 체크해주세요';
        this.messagePop = true;
        this.messageType = '';
        this.$refs.chk2.focus();
        return false;
      }

      return true;
    },
    goPaymentComplete() {
      if (this.duplicatePayCheck) {
        // 중복 결제 체크로직
        return;
      }
      if (!this.validate()) {
        return;
      }
      this.duplicatePayCheck = true;

      this.cardNumber = this.cardNum1 + '-' + this.cardNum2 + '-' + this.cardNum3 + '-' + this.cardNum4;
      this.cardExpireDate = this.expirdateMM + '-' + this.expirdateYY;
      this.ssn = this.ssn1 + '' + this.ssn2 + '' + this.ssn3;

      let reqParam = {};
      if (process.env.NODE_ENV == 'dev') {
        reqParam = {
          request: {
            invoiceSeq: this.seq,
            orderId: this.orderId,
            payInfo: {
              birth: this.ssn,
              cardCode: this.cardName,
              cardNumber1: this.cardNum1,
              cardNumber2: this.cardNum2,
              cardNumber3: document.getElementById('cardNum3').value,
              cardNumber4: document.getElementById('cardNum4').value,
              cardExpireYY: document.getElementById('expirdateYY').value,
              cardExpireMM: document.getElementById('expirdateMM').value,
              cardNumber: this.cardNumber,
              monthInstPlan: 0,
              passwd: this.cardPasswd,
              price: this.prePayment,
            },
          },
          serviceType: '',
        };
      } else {
        reqParam = {
          request: {
            invoiceSeq: this.seq,
            orderId: this.orderId,
            payInfo: {
              birth: this.ssn,
              cardCode: this.cardName,
              cardNumber1: this.cardNum1,
              cardNumber2: this.cardNum2,
              encCardNumber3: this.makeData('cardNum3', 'Y'),
              encCardNumber4: this.makeData('cardNum4', 'Y'),
              encCardExpireMM: this.makeData('expirdateMM', 'Y'),
              encCardExpireYY: this.makeData('expirdateYY', 'Y'),
              cardNumber: this.cardNumber,
              monthInstPlan: 0,
              passwd: this.cardPasswd,
              encPasswd: this.makeData('password', 'Y'),
              price: this.prePayment,
            },
          },
          serviceType: '',
        };
      }

      console.log('========');
      console.log(reqParam);
      this.$refs.header.loadingStart();
      ApiService.service('POST', '/order/auth/prepay', reqParam)
        .then((response) => {
          console.log(response);

          if (response.data.isSucceed) {
            const params = {
              af_order_id: reqParam.request.orderId,
            };
            //const appsFlyerParams = JSON.stringify(params);
            window.appsFlyer('af_month_prepayment_pay', params);
            this.msg = '결제 완료되었습니다.';
            this.messagePop = true;
            this.messageType = 'paymentComplete';
          } else {
            if (response.data.result != null) {
              this.msg = response.data.result.resultMessage;
            } else {
              this.msg = response.data.error;
            }
            this.messagePop = true;
            this.messageType = '';
          }
        })
        .catch((response) => {
          console.log(response);
        })
        .finally(() => {
          this.$refs.header.loadingEnd();
        });
    },
    close() {
      this.messagePop = false;
      this.messageType = '';
    },
    paymentPopClose() {
      this.messagePop = false;
      this.$router.go(-1);
    },
    makeData(id, encrytedYN, plainValue) {
      if (process.env.NODE_ENV == 'dev') return null;
      // eslint-disable-next-line no-undef
      let values = mtk.inputFillEncData(document.getElementById(id));
      let name = document.getElementById(id).name;
      let hidden = values.hidden;
      let hmac = values.hmac;

      // eslint-disable-next-line no-undef
      let keyboardType = transkey[id].keyboard;
      // eslint-disable-next-line no-undef
      let keyIndex = transkey[id].keyIndex;
      // eslint-disable-next-line no-undef
      let fieldType = transkey[id].fieldType;
      let seedKey = document.getElementById('seedKey').value;
      let initTime = document.getElementById('initTime').value;
      let ExE2E = values.ExE2E;

      let newRaonRequest = {};
      newRaonRequest.id = id;
      newRaonRequest.name = name;
      newRaonRequest.keyboardType = keyboardType;
      newRaonRequest.keyIndex = keyIndex;
      newRaonRequest.fieldType = fieldType;
      newRaonRequest.seedKey = seedKey;
      newRaonRequest.initTime = initTime;
      newRaonRequest.transkey = hidden;
      newRaonRequest.transkey_HM = hmac.toString();
      newRaonRequest.transkey_EXE2E = ExE2E;
      newRaonRequest.plainValue = plainValue;
      newRaonRequest.encrytedYN = encrytedYN;

      return newRaonRequest;
    },
  },
};
</script>
